var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-avatar',{attrs:{"icon":_vm.icon,"size":_vm.size,"font-size":_vm.fontSize,"color":_vm.color,"text-color":_vm.textColor}})}
var staticRenderFns = []

export { render, staticRenderFns }